import propertyTypeApi from '../services/api/propertyTypeApi';
import propertyDetachmentApi from '../services/api/propertyDetachmentApi';
import propertyAgeApi from '../services/api/propertyAgeApi';
import addressFinderApi from '../services/api/addressFinderApi';
import addressApi from '../services/api/addressApi';
import propertyApi from '../services/api/propertyApi';
import { formatResponseErrorsForFormik } from '../services/http/errors';
import { getInspection, getHHSRSScoring } from './inspectionDetail';
import { clearAlert, setAlert } from './alerts';

export const RESET = 'EDIT_PROPERTY_DETAILS/RESET';
export const FORM_REFRESHED = 'EDIT_PROPERTY_DETAILS/FORM_REFRESHED';
export const PROPERTY_TYPES_REFRESHED =
    'EDIT_PROPERTY_DETAILS/PROPERTY_TYPES_REFRESHED';
export const PROPERTY_DETACHMENTS_REFRESHED =
    'EDIT_PROPERTY_DETAILS/PROPERTY_DETACHMENTS_REFRESHED';
export const PROPERTY_AGES_REFRESHED =
    'EDIT_PROPERTY_DETAILS/PROPERTY_AGES_REFRESHED';
export const TOGGLE_LOADING = 'EDIT_PROPERTY_DETAILS/TOGGLE_LOADING';
export const SHOW_ADDRESS_LOOKUP = 'EDIT_PROPERTY_DETAILS/SHOW_ADDRESS_LOOKUP';
export const HIDE_ADDRESS_LOOKUP = 'EDIT_PROPERTY_DETAILS/HIDE_ADDRESS_LOOKUP';
export const ADDRESSES_REFRESHED = 'EDIT_PROPERTY_DETAILS/ADDRESSES_REFRESHED';
export const ADDRESS_SELECTED = 'EDIT_PROPERTY_DETAILS/ADDRESS_SELECTED';
export const CLEAR_ADDRESSES = 'EDIT_PROPERTY_DETAILS/CLEAR_ADDRESSES';
export const TOGGLE_LOADING_ADDRESSES =
    'EDIT_PROPERTY_DETAILS/TOGGLE_LOADING_ADDRESSES';

export const formRefreshed = (form) => ({
    type: FORM_REFRESHED,
    form,
});

export const propertyTypesRefreshed = (propertyTypes) => ({
    type: PROPERTY_TYPES_REFRESHED,
    propertyTypes,
});

export const propertyDetachmentsRefreshed = (propertyDetachments) => ({
    type: PROPERTY_DETACHMENTS_REFRESHED,
    propertyDetachments,
});

export const propertyAgesRefreshed = (propertyAges) => ({
    type: PROPERTY_AGES_REFRESHED,
    propertyAges,
});

export const addressesRefreshed = (addresses) => ({
    type: ADDRESSES_REFRESHED,
    addresses,
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    isLoading,
});

export const setSelectedAddress = (address) => ({
    type: ADDRESS_SELECTED,
    address,
});

export const toggleLoadingAddresses = (isLoading) => ({
    type: TOGGLE_LOADING_ADDRESSES,
    isLoading,
});

export const showAddressLookup = () => ({
    type: SHOW_ADDRESS_LOOKUP,
});

export const hideAddressLookup = () => ({
    type: HIDE_ADDRESS_LOOKUP,
});

export const reset = () => ({ type: RESET });

export const clearAddresses = () => ({ type: CLEAR_ADDRESSES });

export const refreshFormOptions = async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        const propertyTypes = (await propertyTypeApi.getAll()).data.data;
        const propertyDetachments = (await propertyDetachmentApi.getAll()).data
            .data;
        const propertyAges = (await propertyAgeApi.getAll()).data.data;

        dispatch(propertyTypesRefreshed(propertyTypes));
        dispatch(propertyDetachmentsRefreshed(propertyDetachments));
        dispatch(propertyAgesRefreshed(propertyAges));

        dispatch(toggleLoading(false));
    } catch ({ response }) {
        dispatch(
            setAlert('Error populating form.', 'error', 'property-details')
        );
    }
};

export const getAddressesByPostcode = (postcode) => async (dispatch) => {
    try {
        dispatch(clearAlert());
        dispatch(toggleLoadingAddresses(true));

        const addresses = (await addressFinderApi.findByPostcode(postcode)).data
            .data;

        addresses.sort((a, b) => {
            const fa = Number(
                a.building_number === '' ? Infinity : a.building_number
            );
            const fb = Number(
                b.building_number === '' ? Infinity : b.building_number
            );

            if (fa < fb) return -1;
            if (fa > fb) return 1;
            return 0;
        });

        dispatch(addressesRefreshed(addresses));

        dispatch(toggleLoadingAddresses(false));
    } catch ({ response }) {
        dispatch(
            setAlert(
                'Error looking up address via postcode.',
                'error',
                'property-details'
            )
        );
    }
};

export const createUpdateAddress = (address) => async (dispatch, getState) => {
    try {
        const { inspection } = getState().pages.inspectionDetail;

        if (address.id) {
            await addressApi.update(address.id, address);
        } else {
            await addressApi.create(address);
        }

        dispatch(hideAddressLookup());
        dispatch(getInspection(inspection.id));

        dispatch(setAlert('Address updated.', 'success', 'property-details'));
    } catch ({ response }) {
        dispatch(
            setAlert(
                'Failed updating the property address.',
                'error',
                'property-details'
            )
        );
    }
};

export const updateProperty =
    (values, { setSubmitting, setErrors, resetForm }, onSuccess) =>
    async (dispatch) => {
        try {
            await propertyApi.update(values.id, values);

            dispatch(reset());
            setSubmitting(false);
            resetForm();
            onSuccess();
            dispatch(getHHSRSScoring(values.inspection_id));
            dispatch(
                setAlert(
                    'Property details updated.',
                    'success',
                    'property-details'
                )
            );
        } catch ({ response }) {
            setSubmitting(false);
            const formattedErrors = formatResponseErrorsForFormik(
                response.data.errors
            );
            setErrors(formattedErrors);
        }
    };
